<template>
    <div class="sy">
      <header>
        <div class="left">
          <!-- <span :class="{active:1===cur}" @click="choose(1)">
            <router-link to="sy">
              <SvgText text="首页" />
            </router-link>
          </span> -->
        </div>
        <div class="middle">
          <SvgText text="中控系统数据分析大屏" x="50%" y="60%" />
        </div>
        <div class="right">
          <!-- <span :class="{active:5===cur}" @click="choose(5)">
            <router-link to="sybx">
              <SvgText text="失业保险" />
            </router-link>
          </span> -->
        </div>
      </header>
      <main class="container">
        <div class="l">
          <Box title="订单数据统计">
            <div class="info">
              <div class="layer">
                <div class="item">
                  <img src="../../assets/img1.png" alt="">
                  <div>
                    <div class="name">总订单量</div>
                    <div class="value">{{dataObj.orderMap.all}}</div>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/img2.png" alt="">
                  <div>
                    <div class="name">上月订单</div>
                    <div class="value">{{dataObj.orderMap.upMonth}}</div>
                  </div>
                </div>
              </div>
              <div class="layer">
                <div class="item">
                  <img src="../../assets/img3.png" alt="">
                  <div>
                    <div class="name">本月订单</div>
                    <div class="value">{{dataObj.orderMap.nowMonth}}</div>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/img4.png" alt="">
                  <div>
                    <div class="name">订单增涨率</div>
                    <div class="value">{{dataObj.orderMap.orderParent}}</div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
          <Box title="本月订单类型分布">
            <Echarts1 :data="dataObj.orderTypeMap" />
          </Box>
          <Box title="本月订单来源分布">
            <Echarts2 :data="eData2" />
          </Box>
        </div>
        <div class="m">
          <section class="map">
            <div class="back" @click="back" v-if="isShow">返回</div>
            <EchartsMap ref="echartsMap" :data="mapData" :area-info="areaInfo" @areaClick="areaClick" />
          </section>
          <Box title="近12个月订单数据分析">
            <Echarts3 :data="eData3" />
          </Box>
        </div>
        <div class="r">
          <Box title="套餐系列在用数量TOP5">
            <Echarts4 :data="eData4" />
          </Box>
          <Box title="对接通道在用数量TOP5">
            <Echarts5 :data="eData5" />
          </Box>
          <Box title="下级代理在用数量TOP5">
            <Echarts6 :data="eData6" />
          </Box>
        </div>
      </main>
    </div>
  </template>
  
<script>
    import EchartsMap from './big/components/EchartsMap'
    import Echarts1 from './big/components/Echarts1'
    import Echarts2 from './big/components/Echarts2'
    import Echarts3 from './big/components/Echarts3'
    import Echarts4 from './big/components/Echarts4'
    import Echarts5 from './big/components/Echarts5'
    import Echarts6 from './big/components/Echarts6'
    import SvgText from '@/component/SvgText'
    import Box from '@/component/Box'
    import {selectAllData,selectCitys} from '@/api/home.js'
    import allJson from '@/assets/map/100000.json'
  
    export default {
        name: '',
        components: {
        EchartsMap,
        Echarts1,
        Echarts2,
        Echarts3,
        Echarts4,
        Echarts5,
        Echarts6,
        SvgText,
        Box
        },
        props: {
    
        },
        data() {
          return {
            isShow:false,
            mapData: [
              { name: '北京市', value: [116.405285, 39.904989], centerId: '110000', num: '0', level: 'province' },
              { name: '天津市', value: [117.190182, 39.125596], centerId: '120000', num: '0', level: 'province' },
              { name: '河南省', value: [113.665412, 34.757975], centerId: '410000', num: '0', level: 'province' },
              { name: '河北省', value: [114.502461, 38.045474], centerId: '130000', num: '0', level: 'province' },
              { name: '山东省', value: [117.000923, 36.675807], centerId: '370000', num: '0', level: 'province' },
              { name: '山西省', value: [112.549248, 37.857014], centerId: '140000', num: '0', level: 'province' },
              { name: '陕西省', value: [108.948024, 34.263161], centerId: '610000', num: '0', level: 'province' },
              { name: '青海省', value: [101.778916, 36.623178], centerId: '630000', num: '0', level: 'province' },
              { name: '甘肃省', value: [103.823557, 36.058039], centerId: '620000', num: '0', level: 'province' },
              { name: '四川省', value: [104.065735, 30.659462], centerId: '510000', num: '0', level: 'province' },
              { name: '云南省', value: [102.712251, 25.040609], centerId: '530000', num: '0', level: 'province' },
              { name: '贵州省', value: [106.713478, 26.578343], centerId: '520000', num: '0', level: 'province' },
              { name: '重庆市', value: [106.504962, 29.533155], centerId: '500000', num: '0', level: 'province' },
              { name: '上海市', value: [121.472644, 31.231706], centerId: '310000', num: '0', level: 'province' },
              { name: '江苏省', value: [118.767413, 32.041544], centerId: '320000', num: '0', level: 'province' },
              { name: '浙江省', value: [120.153576, 30.287459], centerId: '330000', num: '0', level: 'province' },
              { name: '广东省', value: [113.280637, 23.125178], centerId: '440000', num: '0', level: 'province' },
              { name: '广西壮族自治区', value: [108.320004, 22.82402], centerId: '450000', num: '0', level: 'province' },
              { name: '湖南省', value: [112.982279, 28.19409], centerId: '430000', num: '0', level: 'province' },
              { name: '湖北省', value: [114.298572, 30.584355], centerId: '420000', num: '0', level: 'province' },
              { name: '江西省', value: [115.892151, 28.676493], centerId: '360000', num: '0', level: 'province' },
              { name: '辽宁省', value: [123.429096, 41.796767], centerId: '210000', num: '0', level: 'province' },
              { name: '内蒙古自治区', value: [111.670801, 40.818311], centerId: '150000', num: '0', level: 'province' },
              { name: '黑龙江省', value: [126.642464, 45.756967], centerId: '230000', num: '0', level: 'province' },
              { name: '吉林省', value: [125.3245, 43.886841], centerId: '220000', num: '0', level: 'province' },
              { name: '安徽省', value: [117.283042, 31.86119], centerId: '340000', num: '0', level: 'province' },
              { name: '福建省', value: [119.306239, 26.075302], centerId: '350000', num: '0', level: 'province' },
              { name: '新疆维吾尔自治区', value: [87.617733, 43.792818], centerId: '650000', num: '0', level: 'province' },
              { name: '宁夏回族自治区', value: [106.278179, 38.46637], centerId: '640000', num: '0', level: 'province' },
              { name: '西藏自治区', value: [91.132212, 29.660361], centerId: '540000', num: '0', level: 'province' },
              { name: '台湾省', value: [121.509062, 25.044332], centerId: '710000', num: '0', level: 'province' },
              { name: '海南省', value: [110.33119,20.031971], centerId: '460000', num: '0', level: 'province' },
              { name: '香港特别行政区', value: [114.173355, 22.320048], centerId: '810000', num: '0', level: 'province' },
              { name: '澳门特别行政区', value: [113.54909, 22.198951], centerId: '820000', num: '0', level: 'province' }
            ],
            areaInfo: {
              selectedName: '中国',
              areaCode: '100000'
            },
            parentCode: '100000',
            eData1: [],
            eData2: {
              xData: [],
              sData: [],
            },
            eData3: {
              xData: [],
              sData1: [],
              sData2: []
            },
            eData4: {
              yData: [],
              sData: []
            },
            eData5: {
              yData: [],
              sData: []
            },
            eData6: {
              yData: [],
              sData: []
            },
            dataObj:{
              orderMap:{
                all :0
              }
            }
          }
        },
        computed: {
        // mapData() {
        //   var all = allJson.features.map(item => {
        //     return { name: item.properties.name, value: item.properties.center, centerId: item.properties.adcode, num: '0' }
        //   })
        //   return all
        // }
        },
        watch: {
    
        },
        created() {
            this.init()
        },
        mounted() {
    
        },
        methods: {
            back(){
              var all = allJson.features.map(item => {
                  return { name: item.properties.name, value: item.properties.center, centerId: item.properties.adcode, num: '0', level: 'province' }
              })
              this.areaInfo = {
                selectedName: '中国',
                areaCode: '100000'
              }
              this.isShow = false
              all.forEach(item=>{
                this.dataObj.provList.forEach(k=>{
                  if(item.name === k.prov){
                    item.num = k.nums
                  }
                })
              })
              this.mapData = all
            },
            areaClick(params) {
              if (params.data.level === 'province') {
                this.isShow =true
                this.areaInfo.selectedName = allJson.features.find(obj => obj.properties.name === params.name).properties.name
                this.areaInfo.areaCode = allJson.features.find(obj => obj.properties.name === params.name).properties.adcode
                var cityJson = require(`@/assets/map/${this.areaInfo.areaCode}.json`)
                this.mapData = cityJson.features.map(item => {
                  return { name: item.properties.name, value: item.properties.center, centerId: item.properties.adcode, num: '0', level: item.properties.level }
                })
                this.cityData(this.areaInfo.selectedName)
              }
            },
            init(){
              selectAllData().then(res=>{
                this.dataObj = res.data.data
                this.eData2 = {
                  xData:[],
                  sData:[],
                }
                this.eData3 = {
                  xData:[],
                  sData1:[],
                  sData2:[]
                }
                this.eData4 = {
                  yData:[],
                  sData:[],
                }
                this.eData5 = {
                  yData:[],
                  sData:[],
                }
                this.eData6 = {
                  yData:[],
                  sData:[],
                }
                res.data.data.twelveList.forEach(item=>{
                  this.eData3.xData.push(item.month)
                  this.eData3.sData1.push(item.all)
                  this.eData3.sData2.push(item.act)
                })
                res.data.data.createTypeList.forEach(item=>{
                  if(item.name!=='其它订单'){
                    this.eData2.xData.push(item.name)
                    this.eData2.sData.push(item.nums)
                  }
                })
                res.data.data.pkgList.forEach(item=>{
                  this.eData4.yData.push(item.name)
                  this.eData4.sData.push(item.nums)
                })
                res.data.data.supplierList.forEach(item=>{
                  this.eData5.yData.push(item.name)
                  this.eData5.sData.push(item.nums)
                })
                res.data.data.agentList.forEach(item=>{
                  this.eData6.yData.push(item.name)
                  this.eData6.sData.push(item.nums)
                })
                this.mapData.forEach(item=>{
                  res.data.data.provList.forEach(k=>{
                    if(item.name === k.prov){
                      item.num = k.nums
                    }
                  })
                })
              })
            },
            cityData(data){
                selectCitys({prov:data}).then(res=>{
                    if(res.data.data.length === 0) return
                    this.mapData.forEach(item=>{
                        res.data.data.forEach(k=>{
                            if(item.name === k.city){
                                item.num = k.nums
                            }
                        })
                    })
                })
            }
        }
    }
</script>

<style scoped lang="less">
.back{
    background: linear-gradient(0deg, #023D64 0%, #006C9F 100%);
    border: 1px solid #1CAAEB;
    border-radius: 1px;
    width: 60px;
    height: 22px;
    text-align: center;
    font-size: 12px;
    line-height:22px;
    font-family: PingFang SC;
    cursor: pointer;
    color: #fff;
    position: absolute;
    z-index: 9;
}
</style>
  